<template>
  <div>
    <el-dialog :title="this.isCreated ? '新增返利档位配置' : '编辑返利档位配置'" center :visible="true" @close="onClose"
      :close-on-click-modal="false" :close-on-press-escape="false" width="721px">
      <el-form ref="form" :model="form" label-width="120px" size="mini" style="margin-right: 50px">
        <el-form-item label="统计数额达到：" prop="amount">
          <el-input style="width: 120px" v-model="form.amount"></el-input>
        </el-form-item>

        <el-form-item v-if="rebateItemIdConfigurePlace == 'global'" label="返利物品数目：" prop="rebateItemNumber">
          <el-input style="width: 120px" v-model="form.rebateItemNumber"
            :placeholder="rebateItemNumberType == 'number' ? '比如可以填10' : '比如可以填0.1'"></el-input>
          <span v-if="rebateItemNumberType == 'rate'"> x 实际统计数额</span>
        </el-form-item>
        <el-form-item v-else label="奖励：">
          <base-item-selector v-model="form.rewards"
            @updated="(value) => { this.form.rewards = value }"></base-item-selector>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="this.onClose">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const util = require("@/util");
import BaseItemSelector from "@/pages/activity/activity_parameter_template/biz-components/BaseItemSelector";

// 本弹窗名称
const DialogName = "EditRebateGearDialog";

export default {
  data() {
    return {
      form: {
        amount: "",
        rebateItemNumber: "",
        rewards: [],
      },
      isCreated: false,
      rebateItemIdConfigurePlace: "",
      rebateItemNumberType: "",
    };
  },

  computed: {},

  async created() {
    let value = this.$dialogutil.getData(DialogName);

    this.rebateItemIdConfigurePlace = value.rebateItemIdConfigurePlace;
    this.rebateItemNumberType = value.rebateItemNumberType;
    this.isCreated = value.isCreated;

    if (value.entry != null) {
      Object.assign(this.form, value.entry);
    }
  },

  components: {
    BaseItemSelector,
  },

  methods: {
    /**
     * 编辑线上活动
     */
    async submit() {
      if (this.isCreated) {
        await this.add();
      } else {
        await this.update();
      }
    },

    async add() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认新增（该操作不会真的保存配置，需要在上一级页面中保存）？`
        );

        let param = this.save();
        if (param.errMsg) {
          this.$message({
            message: param.errMsg,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "新增成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onCloseWhitParam(param);
      } catch (e) { }
    },
    async update() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认修改（该操作不会真的保存配置，需要在上一级页面中保存）？`
        );

        let param = this.save();

        if (param.errMsg) {
          this.$message({
            message: param.errMsg,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onCloseWhitParam(param);
      } catch (e) { }
    },

    save() {
      this.form.amount = this.form.amount.trim();
      if (!this.form.amount || isNaN(this.form.amount)) {
        return { errMsg: '"统计数额达到"必须是一个数值' };
      }

      this.form.rebateItemNumber = this.form.rebateItemNumber.trim();

      return {
        amount: this.form.amount,
        rebateItemNumber: this.form.rebateItemNumber,
        rewards: this.form.rewards,
      };
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
    onCloseWhitParam(param) {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName, param);
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}

.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}

.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>
